import { render, staticRenderFns } from "./SafeSearch.vue?vue&type=template&id=9dd5807a&scoped=true&"
import script from "./SafeSearch.vue?vue&type=script&lang=js&"
export * from "./SafeSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd5807a",
  null
  
)

export default component.exports